import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=a14a7282&scoped=true&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"
import style0 from "./administrators.vue?vue&type=style&index=0&id=a14a7282&lang=scss&scoped=true&"
import style1 from "./administrators.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14a7282",
  null
  
)

export default component.exports